<div>
    <svg-icon style="
    position: absolute;
    right: 5px;
" (click)="close(false)" [svgStyle]="{ 'width.px':35,'height.px':35 }" src="/assets/icons/close-modal-primary.svg"
        class="cursor-pointer"></svg-icon>
    <img *ngIf="!data.shouldAnonymize" src="{{data.img ?? data}}" class="image-dialog" />
    <img *ngIf="data.shouldAnonymize" src="{{data.img}}" class="image-dialog" />
</div>